import React from 'react';
import '../styles/ProjectCards.css';
import logoStanm from '../assets/logo-stanm.png';

function AboutUs() {
  return (
    <section className="about-section" id="quienes-somos" aria-labelledby="about-title">
      <div className="about-container">
        <h2 id="about-title" className="about-title">Sobre Nosotros</h2>
        <article className="about-main" aria-label="Sobre STAN Multidisciplina">
          <div className="about-main-inner">
            <div className="about-main-image" aria-hidden="true">
              <img src={logoStanm} alt="Logo STAN Multidisciplina" />
            </div>
            <div className="about-main-copy">
              <p>
                EMPRESA DE SERVICIOS PROFESIONALES MULTIDISCIPLINARIOS, DESARROLLO DE INGENIERÍA, ESTUDIO Y GESTIÓN DE DATOS,
                OPTIMIZACIÓN DE PROCESOS, EXPERIENCIA EN GESTIÓN DE PROYECTOS INDUSTRIALES - MINEROS.
              </p>
            </div>
          </div>
        </article>
        <div className="about-columns about-columns-vertical">
          <article className="about-card mission mission-horizontal" id="mision" aria-labelledby="mission-title">
            <div className="mission-flex">
              <div className="mission-text">
                <h3 id="mission-title">Misión</h3>
                <p>
                  Entregar soluciones en ingeniería, procesos y gestión de proyectos multidisciplinarios.
                  Actuar siempre como "OWNER" del requerimiento.
                </p>
              </div>
              <div className="mission-image-container">
                <img src={require('../assets/mision-imagen.png')} alt="Misión" className="mission-image" />
              </div>
            </div>
          </article>

          <article className="about-card vision vision-horizontal" id="vision" aria-labelledby="vision-title">
            <div className="vision-flex">
              <div className="vision-image-container">
                <img src={require('../assets/vision-imagen.png')} alt="Visión" className="vision-image" />
              </div>
              <div className="vision-text">
                <h3 id="vision-title">Visión</h3>
                <p>
                  Queremos crecer junto a nuestros clientes, dejando huella por cómo trabajamos y por los resultados que logramos.
                  Buscamos llevar la minería y la industria a un nuevo nivel con soluciones simples, efectivas y hechas con sentido.
                </p>
              </div>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}

export default AboutUs;